import { requireService } from 'src/packages/di';

export class BroadcastWriteTunnel<T> {
  constructor(private readonly appBroadcastService = requireService('appBroadcastService')) {}

  postMessage(message: T): void {
    this.appBroadcastService.postMessage<T>(message);
  }
}
